import { ApolloError } from 'apollo-boost';
import { Modal } from 'antd';
import { FieldData } from 'rc-field-form/lib/interface';

/**
 * Update fields to add errors from API ValidationException.
 * @param error The ApolloError
 * @param fields The initial fields
 * @return The fields with the errors.
 */
export function handleFormApolloError(
    error: ApolloError,
    fields: FieldData[],
): any[] {
    const validationException = error.graphQLErrors.find(
        (e) => e.extensions && e.extensions.category === 'ValidationException',
    );
    if (!validationException) {
        return fields;
    }
    const formErrors = (validationException as any).formErrors;
    if (!formErrors || formErrors.length === 0) {
        return fields;
    }

    let newFields = [...fields];
    formErrors.forEach(
        (e: { field: string; message: string }, index: number) => {
            const fieldName = e.field.replace('data.', '');
            const fieldIndex = fields.findIndex((f) => {
                if (Array.isArray(f.name)) {
                    return f.name[0] === fieldName;
                } else {
                    return f.name === fieldName;
                }
            });
            if (fieldIndex > -1) {
                newFields[fieldIndex] = {
                    ...newFields[fieldIndex],
                    errors: [e.message],
                    validating: false,
                };
            }
        },
    );

    return newFields;
}

/**
 * Show in a dialog a mail that could not be sent (API MailSendingException), with its cause.
 * The message tells what was saved before the failure (e.g. « Le compte a été créé, mais … »).
 * @param error The ApolloError
 * @return true if the error was a mail sending failure, already shown to the user.
 */
export function showMailSendingError(error: Error): boolean {
    const mailError = (error as ApolloError)?.graphQLErrors?.find(
        (e) => e.extensions && e.extensions.category === 'MailSendingException',
    );
    if (!mailError) {
        return false;
    }
    Modal.error({ title: 'Mail non envoyé', content: mailError.message });
    return true;
}
